const withRetry = async <T>(fn: () => T, timeoutMs: number = 1000, retryCount: number = 3) => {
  try {
    return fn()
  } catch (error) {
    console.error('ERROR, retrying...', error)
    await new Promise((resolve) => setTimeout(resolve, timeoutMs))
    if (retryCount > 0) {
      return withRetry(fn, timeoutMs, retryCount - 1)
    } else {
      throw new Error(`Failed to run function after ${retryCount} retries`)
    }
  }
}

export const Generic = { withRetry }
